import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, DatePicker, Row, Col, Pagination } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import { useHistory } from "react-router-dom";
import { UpdateCurrentRoot } from "redux/actions/appActions";
import TableWidget from "./TableWidget/TableWidget";
import { showAddRecipeListDialog } from "./AddRecipeListPage/showAddRecipeListDialog";
import {
  apiCreateRecipe,
  apiDeleteRecipe,
  apiGetRecipeList,
  apiUpdateRecipe,
} from "services/recipeListService";
const { RangePicker } = DatePicker;

function RecipeListPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    setIsBusy(true);
    apiGetRecipeList(currentPage, pageSize, startDate, endDate)
      .then((data) => {
        setIsBusy(false);
        setDataList(data.dataList)
        setSearchList(data.dataList)
        setTotalCount(data.total_count);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([])
        setSearchList([])
        message.error("Sorry! " + err);
      });
  }, [pageSize, currentPage, startDate, endDate]);

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize
  ) => {
    setPageSize(pageSize);
    setCurrentPage(current);
  };
  const onChange: PaginationProps["onChange"] = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (searchText) => {
    const tmpList = dataList.filter((info) =>
      info.name.toLowerCase().includes(searchText)
    );
    setSearchList([...tmpList]);
  };
  const handleChange = (event) => {
    if (event.target.value === "") {
      setSearchList(dataList);
    } else {
      handleSearch(event.target.value);
    }
  };

  const handleDateFilter = (startDate, endDate) => {
    setCurrentPage(1);
    setStartDate(startDate);
    setEndDate(endDate);
  };
  const onNewRecipe = async () => {
    var res = await showAddRecipeListDialog({
      title: "New Recipe",
      isEditing: false,
    });
    if (res === null) return;
    setIsBusy(true);
    apiCreateRecipe(res)
      .then((data) => {
        setIsBusy(false);
        if (data === null) {
          message.error("There's something wrong while adding New Recipe");
        }
        var tmpData = dataList;
        let updateData = [...dataList];
        updateData.splice(tmpData.length, 0, data);
        tmpData = [...updateData];
        setDataList(tmpData);
        setSearchList(tmpData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Error! " + err);
      });
  };
  const onClickDelete = (pInfo) => {
    setIsBusy(true);
    apiDeleteRecipe(pInfo.id)
      .then((data) => {
        setIsBusy(false);
        let updateData = [...dataList];
        var storeIndex = updateData.findIndex((x) => x.id == pInfo.id);
        updateData.splice(storeIndex, 1);
        var tmpData = [...updateData];
        setDataList(tmpData);
        setSearchList(tmpData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onClickDetail = (pInfo) => {};
  const onClickEdit = async (pInfo) => {
    let info = pInfo;
    var res = await showAddRecipeListDialog({
      title: "Edit Item",
      record: info,
      isEditing: true,
    });
    if (res === null) return;
    setIsBusy(true);
    apiUpdateRecipe(res)
      .then((data) => {
        setIsBusy(false);
        if (data === null) {
          message.error(
            "There's something wrong while updating a Recipe"
          );
        }
        let updateData = [...dataList];
        var storeIndex = updateData.findIndex((x) => x.id == data.id);
        updateData.splice(storeIndex, 1, data);
        setDataList(updateData);
        setSearchList(updateData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>Recipe List</h1>
        <Row>
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              Date Filter Period : &nbsp;&nbsp;
              <RangePicker
                size={"default"}
                onChange={(e, date) => {
                  if (date == null) {
                    handleDateFilter("", "");
                  } else {
                    handleDateFilter(date[0], date[1]);
                  }
                }}
              />
            </div>
          </Col>
          <Col flex={"auto"}>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <TitleSearch
                onSearch={handleSearch}
                onChange={handleChange}
                onPressEnter={handleSearch}
              />
            </div>
          </Col>

          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <CommonButton
                onClick={() => {
                  onNewRecipe();
                }}
              >
                New
              </CommonButton>
            </div>
          </Col>
        </Row>
        <Row justify={"center"} style={{ paddingTop: 16 }}>
          <Col>
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onChange}
              defaultCurrent={1}
              current={currentPage}
              total={totalCount}
              pageSize={pageSize}
            />
          </Col>
        </Row>

        <div style={{ paddingTop: 32 }}>
          <TableWidget
            dataList={searchList}
            onDetailAction={onClickDetail}
            onUpdateAction={onClickEdit}
            onDeleteAction={onClickDelete}
          />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default RecipeListPage;
